import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from './shared/services/global';
import { LoaderService } from './shared/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'KT Web';

  constructor(
    private translate: TranslateService,
    private global: Globals,
    private loaderService:LoaderService
  ){
    translate.setDefaultLang("en");
    translate.use("en");

    this.loaderService.showLoader$.subscribe(showLoader => {
      if (showLoader == true) {
        this.loaderService.showSpinner();
      } else {
        this.loaderService.hideSpinner();
      }
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.global.latitute = position.coords.latitude + '';
        this.global.longitute = position.coords.longitude + '';
      })
    }
  }
}
